import HomeView from './components/pages/Home';
import SignUpView from './components/pages/SignUp';
import LogInView from './components/pages/Login';
import AdminView from './components/pages/Admin';
import CadProduct from './components/pages/ProductAddNew';
import ProductDetails from './components/pages/ProductDetails';
import AdminClient from './components/pages/AdminClient';
import AdminAds from './components/pages/AdminAds';
import VendorProfile from './components/pages/UserVendorProfile';
import Search from './components/pages/Search';
import UserSales from './components/pages/UserSales';
import UserEmail from './components/pages/UserConfigEmail';
import UserSecurity from './components/pages/UserConfigSecufity';
import UserPayment from './components/pages/UserPayments';
import UserDatas from './components/pages/UserData';
import UserShowcase from './components/pages/UserShowcase';
import UserFavorites from './components/pages/UserFavorites';
import UserPurchases from './components/pages/UserPurchases';
import PurchaseConfirm from './components/pages/PurchaseConfirm';
import PasswordReset from './components/pages/PasswordReset';
import AdminTransactions from './components/pages/AdminTransactions';

const Routes = [
  { path: '/', exact: true, noCheck: true, component: HomeView },
  { path: '/usuario/vitrine', noCheck: true, component: UserShowcase },
  { path: '/busca', noCheck: true, component: Search },
  { path: '/entrar', noCheck: true, component: LogInView },
  { path: '/recuperar-senha', component: PasswordReset },
  { path: '/admin', exact: true, noCheck: true, component: AdminView },
  { path: '/admin/users', noCheck: true, component: AdminClient },
  { path: '/admin/ads', noCheck: true, component: AdminAds },
  { path: '/admin/charges', noCheck: true, component: AdminTransactions },
  { path: '/usuario/cadastro', noCheck: true, component: SignUpView },
  { path: ['/usuario/vendas/:tab', '/usuario/vendas'], noCheck: true, component: UserSales },
  { path: '/usuario/anunciante', noCheck: true, component: VendorProfile },
  { path: '/usuario/pagamentos', noCheck: true, component: UserPayment },
  { path: '/usuario/configuracoes/emails', noCheck: true, component: UserEmail },
  { path: '/usuario/configuracoes/seguranca', noCheck: true, component: UserSecurity },
  { path: '/produto/cadastro', noCheck: true, component: CadProduct },
  { path: '/produto/detalhes/:prodId', noCheck: true, component: ProductDetails },
  { path: '/usuario/configuracoes/meusdados', noCheck: true, component: UserDatas },
  { path: '/usuario/favoritos', noCheck: true, component: UserFavorites },
  { path: ['/usuario/compras', '/usuario/compras/:tab'], noCheck: true, component: UserPurchases },
  { path: '/confirmacompra', noCheck: true, component: PurchaseConfirm }
];

export const NoPermissionPage = HomeView;
export default Routes;
